import type { FC } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Dialog } from '@sravni/react-design-system/lib/Dialog';
import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import styles from './ServiceBannerInfoSheet.module.scss';
import { ServiceBannerInfoSheetTexts } from './ServiceBannerInfoSheet.texts';

type ServiceBannerInfoSheetProps = {
  visible: boolean;
  onClose: (event: React.MouseEvent | KeyboardEvent | PopStateEvent) => void;
};

export const ServiceBannerInfoSheet: FC<ServiceBannerInfoSheetProps> = ({ visible, onClose }) => {
  const isMobile = useIsMobile();

  const Variant = isMobile ? Sheet : Dialog;

  return (
    <Variant visible={visible} onClose={onClose} className={styles.container}>
      <Variant.Header title={ServiceBannerInfoSheetTexts.title} />
      <Variant.Content>
        <Space direction="vertical" size={8}>
          <Text className={styles.content}>{ServiceBannerInfoSheetTexts.content}</Text>
          <br />
          <Text className={styles.content}>{ServiceBannerInfoSheetTexts.description}</Text>
        </Space>
      </Variant.Content>
      <Variant.Footer>
        <Button onClick={onClose} variant="primary" block size={52}>
          {ServiceBannerInfoSheetTexts.buttonText}
        </Button>
      </Variant.Footer>
    </Variant>
  );
};
